<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  <section [formGroup]="getControl('data')">
    <div class="container start-page">
      <div>
        <p>
          Please answer the questions below to complete the BCC Treatment Plan
          Extension Request. This page asks for information about the request.
        </p>
        <h1 class="section-header">Member Information</h1>
        <hr />
        <div class="d-flex align-items-center">
          <h2 class="person-label">Name:</h2>
          <span class="ps-2 pb-1">{{ name }}</span>
        </div>
        <br />
        <div class="d-flex align-items-center">
          <h2 class="person-label">Date of Birth:</h2>
          <span class="ps-2 pb-1">{{ dob }}</span>
        </div>
        <br />
        <div class="d-flex align-items-center">
          <h2 class="person-label">Social Security Number:</h2>
          <span class="ps-2 pb-1">{{ formattedSSN }}</span>
        </div>
        <br />
        <div class="d-flex align-items-center">
          <h2 class="person-label">Gender:</h2>
          <span class="ps-2 pb-1">{{ gender }}</span>
        </div>
        <br />
        <p class="static-text">
          <b
            ><span class="requiredfd" aria-hidden="true">*</span>Can you confirm
            you want to submit a BCC Treatment Plan Extension for {{ name }}?
          </b>
          <span class="visually-hidden">required</span>
        </p>

        <div class="row g-3 py-2">
          <div class="d-flex">
            <label
              class="radio-inline checkbox"
              for="requestExtenssionYesCheck"
            >
              <input
                #checkYes
                [checked]="checkboxValue?.code === 'Y'"
                class="chk-input chk-gap"
                id="requestExtensionYesCheck"
                type="radio"
                (change)="requestExtension($event, checkNo)"
                name="requestExtensionYesCheck"
                value="Yes"
                aria-required="true"
                aria-label="Yes submit BCC Treatment Plan Extension"
              />
              <label class="chk-lbl">{{ "Yes" | translate }}</label>
            </label>

            <label class="radio-inline checkbox" for="requestExtenssionNoCheck">
              <input
                #checkNo
                [checked]="checkboxValue?.code === 'N'"
                class="chk-input chk-gap"
                id="requestExtensionNoCheck"
                type="radio"
                (change)="requestExtension($event, checkYes)"
                name="requestExtensionNoCheck"
                value="No"
                aria-required="true"
                aria-label="No do not submit BCC Treatment Plan Extension"
              />
              <label class="chk-lbl">{{ "No" | translate }}</label>
            </label>
          </div>
        </div>
        @if (enablefollowupApptDt) {
        <div>
          <br />
          <h2 class="section-header">BCC Treatment Extension Information</h2>
          <hr />
          <nh-field
            id="followupApptDt"
            label="Date of Follow Up Appointment"
            [mandatory]="false"
            [attr.aria-required]="false"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                name="followupApptDt"
                aria-label="followupApptDate"
                class="form-control"
                formControlName="followupApptDt"
                bsDatepicker
                nh
                [minDate]="minimumDate"
                [maxDate]="maximumDate"
                maxLength="10"
              />
            </nh-datepicker>
          </nh-field>
          <nh-field
            id="reasonForExtension"
            label="Reason for BCC Treatment Plan Extension"
            class="label-section"
          >
            <select
              nh
              name="reasonForExtension"
              aria-label="reasonForExtension"
              [items]="tables.BCCEXTENSIONREASON"
              formControlName="reasonForExtension"
            ></select>
          </nh-field>
        </div>
        }
      </div>
    </div>
  </section>
</nh-form>